export type OpportunityTypesTableRow = {
  opportunityType: string
  count: string
}

export enum ROIDataType {
  INFLUENCED = 'influenced',
  SOURCED = 'sourced',
}
